import { render, staticRenderFns } from "./Abbonato.vue?vue&type=template&id=2fcb8b9c&"
import script from "./Abbonato.vue?vue&type=script&lang=js&"
export * from "./Abbonato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Abbonato.vue"
export default component.exports